export default {
  mounted () {
    const el = document.getElementById('ProductAccordion-Description-' + this.$el.closest('[id^="shopify-section"]').id.replace('shopify-section-', ''))
    if (!el) return

    const toggleAccordionState = () => {
      if (window.innerWidth >= 750) {
        el.setAttribute('open', '')
      } else {
        el.removeAttribute('open')
      }
    }

    toggleAccordionState()
    window.addEventListener('resize', toggleAccordionState)

    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', toggleAccordionState)
    })
  }
}
